export class AoSharedTools {
  public static isValidLatLng(latitude: any, longitude: any): boolean {
    return (
      Number(latitude) !== 0 &&
      Number(longitude) !== 0 &&
      !isNaN(Number(latitude)) &&
      !isNaN(Number(longitude))
    );
  }

  public static getColorPath(
    colorAndSpeed: { speed: number; color: string }[],
  ): {
    speedMin: number;
    speedMax: number;
    color: string;
  }[] {
    const array: { speedMin: number; speedMax: number; color: string }[] = [];
    colorAndSpeed.sort((a, b) => a.speed - b.speed);
    colorAndSpeed.forEach((item, index) => {
      if (index === colorAndSpeed.length - 1) {
        array.push({ speedMin: item.speed, speedMax: 400, color: item.color });
        return;
      }
      array.push({
        speedMin: item.speed,
        speedMax: colorAndSpeed[index + 1].speed,
        color: item.color,
      });
    });
    return array;
  }
  public static convertSecondsDurationToString(duration: number): string {
    const hours = Math.trunc(duration / 60 / 60);
    let minutes = Math.round((duration - hours * 60 * 60) / 60);
    const seconds = duration - hours * 60 * 60 - minutes * 60;
    minutes = seconds > 30 ? minutes + 1 : minutes;

    return `${('0' + hours).slice(-2)}:${('0' + minutes).slice(-2)}`;
  }
  public static convertStringDurationToSeconds(duration: string): number {
    const d = duration.split(':');
    if (d.length !== 3) {
      // CustomLogger.e(`Invalid duration "${duration}", expected "xx:xx:xx"`);
      return 0;
    }
    const seconds = parseInt(d[2]);
    let minutes = parseInt(d[1]);
    const hours = parseInt(d[0]);
    minutes = seconds > 30 ? minutes + 1 : minutes;

    return hours * 60 * 60 + minutes * 60;
  }
  public static getDistance(
    pos1: google.maps.LatLng,
    pos2: google.maps.LatLng,
  ): number {
    const R = 6371.071; // Radius of the Earth in miles
    const rlat1 = pos1.lat() * (Math.PI / 180); // Convert degrees to radians
    const rlat2 = pos2.lat() * (Math.PI / 180); // Convert degrees to radians
    const difflat = rlat2 - rlat1; // Radian difference (latitudes)
    const difflon = (pos2.lng() - pos1.lng()) * (Math.PI / 180); // Radian difference (longitudes)

    const d =
      2 *
      R *
      Math.asin(
        Math.sqrt(
          Math.sin(difflat / 2) * Math.sin(difflat / 2) +
            Math.cos(rlat1) *
              Math.cos(rlat2) *
              Math.sin(difflon / 2) *
              Math.sin(difflon / 2),
        ),
      );
    return d;
  }

  public static getMaxDistance(latLng: google.maps.LatLng[]): number {
    return Math.max(
      ...latLng.map((l, i, latLngs) =>
        AoSharedTools.getDistance(latLngs[0], latLngs[i]),
      ),
    );
  }
}
